import React from 'react'

import AgentPage from '../../components/templates/AgentPage'
import useStyles from './styles'

interface ErrorPageDetailsProps {
  classes: any
}

const ErrorPageDetails: React.FC<ErrorPageDetailsProps> = React.memo(
  ({ classes }) => (
    <div className={classes.root}>
      <div className='title'>Cannot view resource</div>

      <div className='message'>
        You may lack permission or the resource may not exist.
      </div>
    </div>
  )
)

interface PermissionErrorPageProps {
  skipAgentPage?: boolean
}

const PermissionErrorPage: React.FC<PermissionErrorPageProps> = React.memo(
  ({ skipAgentPage }) => {
    const classes = useStyles()

    if (skipAgentPage) return <ErrorPageDetails classes={classes} />
    return (
      <AgentPage>
        <ErrorPageDetails classes={classes} />
      </AgentPage>
    )
  }
)

export default PermissionErrorPage
